const formatters = new Map<string, Intl.NumberFormat>();
let locale = "tr-TR";

/** Sayı biçimi yereli (varsayılan tr-TR: 1.234,57; en-US: 1,234.57). Rapor dili değişince web ayarlar. */
export function setNumberLocale(next: string): void { locale = next; }
export function getNumberLocale(): string { return locale; }

/** Yerel biçimde sayı (varsayılan TR: 1.234,57). Geçersiz sayı için "—". */
export function fmt(value: number, digits = 2): string {
  if (!Number.isFinite(value)) return "—";
  const key = `${locale}:${digits}`;
  let f = formatters.get(key);
  if (!f) {
    f = new Intl.NumberFormat(locale, { minimumFractionDigits: digits, maximumFractionDigits: digits });
    formatters.set(key, f);
  }
  // Intl "-0,00" üretebilir; sıfıra yuvarlananları düzelt
  const s = f.format(value);
  return s === "-" + f.format(0) ? f.format(0) : s;
}
